import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { ControllaFirmaDTO } from "@app/shared/dto/protocollo/controlla-firmaDTO";
import { ControllaFirmaVO } from "@app/shared/vo/controlla-firmaVO";
import { MapperInfoFirma } from "@app/shared/mapper/edocumento/mapper-info-firma";

@Injectable({
  providedIn: "root"
})
export class MapperControlloFirma
  implements MapperInterface<ControllaFirmaDTO, ControllaFirmaVO> {
  convertVoToDto(e: ControllaFirmaVO): ControllaFirmaDTO {
    throw new Error("Method not implemented.");
  }
  convertDtoToVo(t: ControllaFirmaDTO): ControllaFirmaVO {
    console.log("[mapperControlloFirma]", t);
    const controllaFirmaVO = new ControllaFirmaVO();

    controllaFirmaVO.dataVerifica = t.dataVerifica;
    controllaFirmaVO.statoVerifica = t.statoVerifica;
    controllaFirmaVO.errorCode = t.errorCode;

    controllaFirmaVO.info = this.mapperInfoFirma.convertListDtoToVo(t.info);

    console.log("[mapperControlloFirma]", controllaFirmaVO);

    return controllaFirmaVO || new ControllaFirmaVO();
  }
  convertListVoToDto(e: ControllaFirmaVO[]): ControllaFirmaDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(t: ControllaFirmaDTO[]): ControllaFirmaVO[] {
    throw new Error("Method not implemented.");
  }

  constructor(private mapperInfoFirma: MapperInfoFirma) {}
}
